import { TeamNoteConfig } from '../configs/models/config';
import { BasicUatConfig } from './basic_uat/basic_uat.config';
import { DemoConfig } from './demo/demo.config';

export const TeamNoteCategoryConfig: {[domain: string]: TeamNoteConfig} = {
  // 'uat': BasicUatConfig,
  'demo': DemoConfig
}